import { put, takeLatest } from "redux-saga/effects";
import { types } from "../action_types";
import { GET, POST } from "../../Utils/httpServices";
import CustomToster from "../../SharedComponents/CustomToaster";

const getToken = () => window.sessionStorage.getItem("token");

function* GetSuspiciousActivitiesSaga({ payload }) {
  try {
    const { page = 1, limit = 20, type, severity, resolved } = payload || {};
    let url = `admin/anti-cheat/activities?page=${page}&limit=${limit}`;
    if (type) url += `&type=${type}`;
    if (severity) url += `&severity=${severity}`;
    if (resolved !== undefined && resolved !== "") url += `&resolved=${resolved}`;

    const response = yield GET(url, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    if (response?.status === 200) {
      yield put({
        type: types.GetSuspiciousActivitiesRequestSuccess,
        payload: response?.data?.data,
      });
    } else {
      yield put({ type: types.GetSuspiciousActivitiesRequestFailure });
    }
  } catch (e) {
    CustomToster({
      type: "error",
      message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message,
    });
    yield put({ type: types.GetSuspiciousActivitiesRequestFailure });
  }
}

function* GetAntiCheatStatsSaga() {
  try {
    const response = yield GET(`admin/anti-cheat/stats`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    if (response?.status === 200) {
      yield put({
        type: types.GetAntiCheatStatsRequestSuccess,
        payload: response?.data?.data,
      });
    } else {
      yield put({ type: types.GetAntiCheatStatsRequestFailure });
    }
  } catch (e) {
    yield put({ type: types.GetAntiCheatStatsRequestFailure });
  }
}

function* ResolveSuspiciousActivitySaga({ payload }) {
  try {
    const { id, resolution, note } = payload;
    const response = yield POST(
      `admin/anti-cheat/activities/${id}/resolve`,
      { resolution, note },
      { headers: { Authorization: `Bearer ${getToken()}` } }
    );

    if (response?.status === 200) {
      yield put({
        type: types.ResolveSuspiciousActivityRequestSuccess,
        payload: { id, resolution },
      });
      CustomToster({
        type: "success",
        message: "Activity resolved successfully",
      });
    } else {
      yield put({ type: types.ResolveSuspiciousActivityRequestFailure });
    }
  } catch (e) {
    CustomToster({
      type: "error",
      message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message,
    });
    yield put({ type: types.ResolveSuspiciousActivityRequestFailure });
  }
}

export default function* AntiCheatSaga() {
  yield takeLatest(types.GetSuspiciousActivitiesRequest, GetSuspiciousActivitiesSaga);
  yield takeLatest(types.GetAntiCheatStatsRequest, GetAntiCheatStatsSaga);
  yield takeLatest(types.ResolveSuspiciousActivityRequest, ResolveSuspiciousActivitySaga);
}
